import React, {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {ModerationFilterProps} from './moderation-filter.constants'
import {ScreenSize} from '../../settings/device'
import { keyDownEvents, keyPressEvents } from '../../store/types'

export type ModerationStateValueType = {
  state: string
  value: string
}

type useModerationFilterHookProps = ModerationFilterProps
type useModerationFilterHookType = ModerationFilterProps & {
  onFocus: boolean
  drawerStatus: boolean
  btnDisabled: boolean
} & {
  isApply: () => boolean
  changeModerationState: (prop: ModerationStateValueType | null) => void
  toggleDrawer: (
    open: boolean
  ) => (event: React.KeyboardEvent | React.MouseEvent) => void | undefined
  applyBtnHandler: () => void
} & {
  setOnfocus: Dispatch<SetStateAction<boolean>>
  setDrawerStatus: Dispatch<SetStateAction<boolean>>
  setBtnDisabled: Dispatch<SetStateAction<boolean>>
}

export const useModerationFilterHook = (props: useModerationFilterHookProps): useModerationFilterHookType => {
  const {
    screenSize,
    onFilterChanged,
    loading,
    cancelHandler,
    setFilterCollapsed,
    isFilterCollapsed,
    moderationState,
    settings,
  } = props

  useEffect(() => {
    if (screenSize === 1) {
      setFilterCollapsed(false)
    }
  }, [])

  const [onFocus, setOnfocus] = useState<boolean>(false)
  const [drawerStatus, setDrawerStatus] = useState<boolean>(false)
  const [btnDisabled, setBtnDisabled] = useState<boolean>(true)

  /*Param that defined reload*/
  const isApply = () => {
    return screenSize !== ScreenSize.Mobile
  }

  /*DrawerManager*/
  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === keyPressEvents.keydown &&
        ((event as React.KeyboardEvent).key === keyDownEvents.tab ||
          (event as React.KeyboardEvent).key === keyDownEvents.shift)
      ) {
        return
      }
      setDrawerStatus(open)
    }

  /*Apply Btn Button*/
  const applyBtnHandler = () => {
    setDrawerStatus(false)
    onFilterChanged({}, true, true)
    setBtnDisabled(true)
  }

  /* Set Items State*/
  const changeModerationState = (prop: ModerationStateValueType | null) => {
    setBtnDisabled(false)
    onFilterChanged(
      {
        moderationState: prop ? prop.value : '',
      },
      isApply(),
      true
    )
  }

  return {
    //props
    screenSize,
    onFilterChanged,
    loading,
    cancelHandler,
    setFilterCollapsed,
    isFilterCollapsed,
    moderationState,
    settings,

    //methods
    isApply,
    toggleDrawer,
    applyBtnHandler,
    changeModerationState,

    //state
    onFocus,
    drawerStatus,
    btnDisabled,

    //state methods
    setOnfocus,
    setBtnDisabled,
    setDrawerStatus,
  }
}
